module.exports = "/_next/static/images/bg-info-extend-4-d2bdecd1.png";